import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { CSSProperties } from "react"
import { connect } from "react-redux"
import { Select } from "antd"
import { Color } from "../../../constants"
import { getSelectedLocationId, getSelectedLocationOverrideId } from "./selectors"
import { locationOverrideSelected } from "./actions"
import { cookieNames, deleteCookie, setCookie } from "../../../utils/cookies"
import { areLocationsAuthDataLoaded, getLocationsAuthData, hasMasterListAccess } from "../../auth/selectors"
import type { LocationAuthData } from "../../auth/types"

type Props = {
    locations: LocationAuthData[]
    selectedLocationId: string
    style?: Record<string, string>
    masterListAccess: boolean
    locationsLoaded: boolean
    // Not required
    onLocationsSelected: (id: Maybe<string>) => void
}

class SingleLocationOverridePicker extends React.PureComponent<Props> {
    static defaultProps = {
        style: {
            width: "10rem",
        },
    }

    myRef = React.createRef()
    onLocationSelected = (key: Maybe<string>) => {
        if (key) {
            setCookie(cookieNames.overrideLocationId, key)
        } else {
            deleteCookie(cookieNames.overrideLocationId)
        }

        this.props.onLocationsSelected(key)
    }

    render() {
        if (this.props.locationsLoaded && this.props.locations.length <= 1) {
            // TODO there is margin in several components wrapping this component, someone should remove it
            // return null
        }
        return (
            <div
                // @ts-expect-error
                ref={this.myRef}
                style={{
                    position: "relative",
                    zIndex: 10,
                }}>
                <style jsx={true} global={true}>
                    {`
                        .location-non-master .ant-select-selection {
                            border-color: rgba(255, 152, 0, 0.65);
                            background-color: #fffbe6;
                        }
                        .location-non-master .ant-select-selection:hover,
                        .ant-select-selection:focus {
                            border-color: rgba(255, 152, 0, 0.65);
                            background-color: #fffbe6;
                        }
                    `}
                </style>
                <div className={!this.props.selectedLocationId ? "location-master" : "location-non-master"}>
                    <Select
                        loading={!this.props.locationsLoaded}
                        disabled={!this.props.locationsLoaded}
                        showSearch={true}
                        optionFilterProp="children"
                        // @ts-expect-error
                        getPopupContainer={() => this.myRef.current}
                        filterOption={(input, option) =>
                            // @ts-expect-error
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        style={{
                            width: "10rem",
                            ...this.props.style,
                        }}
                        value={this.props.locationsLoaded ? this.props.selectedLocationId || "Master List" : null}
                        onChange={this.onLocationSelected}>
                        {/* TODO DO not display select when only one location exists */}
                        {this.props.masterListAccess ? (
                            // @ts-expect-error
                            <Select.Option style={styles.masterOption} value={null}>
                                Master List
                            </Select.Option>
                        ) : null}

                        {this.props.locations?.length > 0
                            ? this.props.locations.map(l => (
                                  <Select.Option key={l.id} value={l.id}>
                                      {l.name}
                                  </Select.Option>
                              ))
                            : null}
                    </Select>
                </div>
            </div>
        )
    }
}

const styles: Record<string, CSSProperties> = {
    masterOption: {
        borderBottom: `1px solid ${Color.BorderAdaptive}`,
    },
}

const mapStateToProps = state => ({
    locations: getLocationsAuthData(state),
    selectedLocationId: getSelectedLocationOverrideId(state),
    masterListAccess: hasMasterListAccess(state),
    locationsLoaded: areLocationsAuthDataLoaded(state) && !!getSelectedLocationId(state),
})

const mapDispatchToProps = {
    onLocationsSelected: locationOverrideSelected,
}
export default connect<any, any, any>(mapStateToProps, mapDispatchToProps)(SingleLocationOverridePicker)
